// extracted by mini-css-extract-plugin
export default {"item":"OFUinjQE","text":"J4MlENef","inline":"FE_qBBqR","small-badge":"W8de0Ke5","focus":"VY1YnxLU"};